import React from "react";
import { Github, Linkedin, Mail, ArrowUpRight } from "lucide-react";
import { personalInfo } from "../data/mock";

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="relative min-h-screen flex items-center overflow-hidden pt-24 pb-16">
      <div className="absolute inset-0 grid-backdrop pointer-events-none" />

      {/* Left side rail with social icons */}
      <div className="hidden lg:flex fixed left-8 bottom-0 flex-col items-center gap-6 z-40">
        <a
          href={personalInfo.github}
          target="_blank"
          rel="noopener noreferrer"
          className="text-ink-2 hover:text-accent hover:-translate-y-1 transition-all"
          aria-label="GitHub"
        >
          <Github className="w-4 h-4" strokeWidth={1.5} />
        </a>
        <a
          href={personalInfo.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="text-ink-2 hover:text-accent hover:-translate-y-1 transition-all"
          aria-label="LinkedIn"
        >
          <Linkedin className="w-4 h-4" strokeWidth={1.5} />
        </a>
        <a
          href={`mailto:${personalInfo.email}`}
          className="text-ink-2 hover:text-accent hover:-translate-y-1 transition-all"
          aria-label="Email"
        >
          <Mail className="w-4 h-4" strokeWidth={1.5} />
        </a>
        <div className="h-24 w-px bg-rule" />
      </div>

      {/* Right side rail with vertical email */}
      <div className="hidden lg:flex fixed right-8 bottom-0 flex-col items-center gap-6 z-40">
        <a
          href={`mailto:${personalInfo.email}`}
          className="font-mono text-xs text-ink-2 hover:text-accent hover:-translate-y-1 transition-all"
          style={{ writingMode: "vertical-rl" }}
        >
          {personalInfo.email}
        </a>
        <div className="h-24 w-px bg-rule" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10 w-full">
        <div className="max-w-4xl">
          {/* Status pill */}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-rule bg-bg-elev mb-8">
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-accent opacity-70 animate-ping" />
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-accent" />
            </span>
            <span className="font-mono text-[11px] text-ink-2 tracking-wider">
              {personalInfo.availability.toUpperCase()}
            </span>
            <span className="text-ink-3 font-mono text-[11px]">/</span>
            <span className="font-mono text-[11px] text-ink-2 tracking-wider">
              {personalInfo.location.toUpperCase()}
            </span>
          </div>

          <p className="font-mono text-sm text-accent mb-5">
            $ whoami<span className="caret" />
          </p>

          <h1 className="font-sans font-semibold text-ink leading-[0.95] tracking-tightest text-[3.25rem] sm:text-6xl md:text-7xl lg:text-[5.5rem] mb-4">
            {personalInfo.name}.
          </h1>

          <h2 className="font-sans font-semibold text-ink-2 leading-[1.05] tracking-tighter2 text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-8">
            {personalInfo.tagline}
          </h2>

          <p className="text-base md:text-lg leading-relaxed text-ink-2 max-w-2xl mb-10">
            {personalInfo.subtitle}
          </p>

          <div className="flex flex-wrap items-center gap-4">
            <button
              onClick={scrollToContact}
              className="group inline-flex items-center gap-2 px-5 py-3 border border-accent text-accent rounded-md hover:bg-accent-dim transition-all font-mono text-sm"
            >
              get in touch
              <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" strokeWidth={2} />
            </button>
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 text-ink-2 hover:text-ink transition-colors font-mono text-sm"
            >
              view github
              <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
